import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactTable from "../../AppComponent/Table";
import _ from "lodash";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import {
  GetEmployeeBulkUploadDataRequest,
  GetSheetBulkUploadDataSucess,
  SheetBulkUploadSucess,
} from "../../../Redux/Slice";
import { FaDownload } from "react-icons/fa";
import EmployeeBulkuploadPopup from "./EmployeeBulkuploadPopup";
import { useNavigate } from "react-router-dom";
import yesIcon from "../../../Assets/yes.png";
import errorIcon from "../../../Assets/error.png";
import fileDownloadIcon from "../../../Assets/fileDownload.png";

const EmployeeBulkuploadMain = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const dispatch = useDispatch();
  const [sno, setsno] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [search, setsearch] = useState("");
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const navigate = useNavigate();

  const { employeeBulkUploaddata, totalCount } = useSelector(
    (state) => state.employeeBulkUploadGetData,
  );

  console.log(employeeBulkUploaddata, "kdlksakldalkdlkalk");
  const [bulkUploadPopup, setBulkUploadPopup] = useState(false);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        // console.log("Searching for:", e);

        setsearch(e);
      }, 500),
    [],
  );
  function tochange(e) {
    setdtPageindex(1);
    // setsearch(e);
    debouncedSearch(e);
  }

  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handleDownload = (url) => {
    if (!url) return;

    window.open(url, "_blank");
  };

  useEffect(() => {
    const payload = {
      page_size: 20,
      page: 1,
      search: "",
    };
    dispatch(GetEmployeeBulkUploadDataRequest(payload));
  }, []);
  useEffect(() => {
    const payload = {
      page_size: 20,
      page: dtpageindex,
      search: "",
    };
    dispatch(GetEmployeeBulkUploadDataRequest(payload));
  }, [dtpageindex]);
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(
        GetEmployeeBulkUploadDataRequest({
          page_size: 20,
          page: dtpageindex,
          search: "",
        }),
      );
    }, 10000);

    return () => clearInterval(interval);
  }, [dispatch, dtpageindex]);
  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "S.NO",
        accessor: "",
        Cell: (row) => {
          console.log(row.row);
          console.log(sno);
          return <p>{Number(sno + row.row.index + 1)}</p>;
        },
      },

      {
        Header: "Employee Name",
        accessor: "employee_name",
        Cell: (row) => {
          return (
            <>
              <span
                style={{
                  width: "160px",
                  display: "inline-block",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  textWrap: "wrap",
                }}
              >
                {row.row.original?.employee_name}
              </span>
            </>
          );
        },
      },
      {
        Header: "Employeement Type",
        accessor: "employee_type",
        Cell: (row) => {
          const type = row.row.original?.employee_type;
          return (
            <>
              <span>
                {type == "0"
                  ? "Permanent"
                  : type == "1"
                    ? "Contractual"
                    : type == "2"
                      ? "Consultant"
                      : type == "3"
                        ? "Freelancer"
                        : type == "4"
                          ? "Intern"
                          : type == "5"
                            ? "Apprentice"
                            : "-"}
              </span>
            </>
          );
        },
      },
      {
        Header: "Phone Number",
        accessor: "phone_number",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.phone_number}</span>
            </>
          );
        },
      },
      {
        Header: "Email",
        accessor: "email",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.email}</span>
            </>
          );
        },
      },

      {
        Header: "Aadhar Number",
        accessor: "aadhar_number",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.aadhar_number}</span>
            </>
          );
        },
      },
      {
        Header: "Pan Number",
        accessor: "pan_number",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.pan_number}</span>
            </>
          );
        },
      },

      {
        Header: "Aadhar Pan Link Status",
        accessor: "aadhar_pan_linked",
        Cell: (row) => {
          return (
            <>
              <img
                src={row.row.original?.aadhar_pan_linked ? yesIcon : errorIcon}
                alt={row.row.original?.aadhar_pan_linked ? "Yes" : "No"}
                style={{ width: "30px", height: "30px" }}
              />
            </>
          );
        },
      },
      {
        Header: "Pan Verified",
        accessor: "pan_verified",
        Cell: (row) => {
          return (
            <>
              <img
                src={row.row.original?.pan_verified ? yesIcon : errorIcon}
                alt={row.row.original?.pan_verified ? "Yes" : "No"}
                style={{ width: "30px", height: "30px" }}
              />
            </>
          );
        },
      },
      {
        Header: "Gst Pan Link Status",
        accessor: "gst_pan_linked",
        Cell: (row) => {
          return (
            <>
              <img
                src={row.row.original?.gst_pan_linked ? yesIcon : errorIcon}
                alt={row.row.original?.gst_pan_linked ? "Yes" : "No"}
                style={{ width: "30px", height: "30px" }}
              />
            </>
          );
        },
      },
      {
        Header: "Project Name",
        accessor: "project",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.project}</span>
            </>
          );
        },
      },
      {
        Header: "Designation",
        accessor: "designation",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.designation}</span>
            </>
          );
        },
      },
      {
        Header: "Date Of Birth",
        accessor: "date_of_birth",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.date_of_birth}</span>
            </>
          );
        },
      },
      {
        Header: "Date Of Joining",
        accessor: "date_of_joining",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.date_of_joining}</span>
            </>
          );
        },
      },
      {
        Header: "HRA Salary",
        accessor: "hra_salary",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.hra_salary}</span>
            </>
          );
        },
      },
      {
        Header: "Accident Insurance",
        accessor: "accident_insurance",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.accident_insurance}</span>
            </>
          );
        },
      },
      {
        Header: "Medical Insurance",
        accessor: "medical_insurance",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.medical_insurance}</span>
            </>
          );
        },
      },
      {
        Header: "Marital Status",
        accessor: "marital_status",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.marital_status}</span>
            </>
          );
        },
      },
      {
        Header: "Role",
        accessor: "role",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.role}</span>
            </>
          );
        },
      },
      {
        Header: "State",
        accessor: "state",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.state}</span>
            </>
          );
        },
      },
      {
        Header: "Location",
        accessor: "location",
        Cell: (row) => {
          return (
            <>
              <span>{row.row.original?.location}</span>
            </>
          );
        },
      },

      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;
          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
          return (
            <>
              <span style={{ textWrap: "nowrap" }}>
                {`${
                  row.row.original.created_at.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </span>
            </>
          );
        },
      },

      {
        Header: "Offer Letter",
        accessor: "offer_letter",
        Cell: (row) => {
          const url = row.row.original?.offer_letter;

          return url ? (
            <span
              onClick={() => handleDownload(url)}
              title="Download Uploaded Sheet"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                cursor: "pointer",
                border: "1px solid green",
                backgroundColor: "green",
                padding: "3px 7px",
                color: "white",
                borderRadius: "5px",
              }}
            >
              <img
                src={fileDownloadIcon}
                alt="Download"
                style={{ width: "30px", height: "30px" }}
              />{" "}
              <span>Download</span>
            </span>
          ) : null;
        },
      },
    ],

    [employeeBulkUploaddata],
  );

  const sampleData = [
    {
      id: 1,
      name: "Pradap",
      email: "pradap@test.com",
      role: "Admin",
      status: "Active",
    },
    {
      id: 2,
      name: "Arun",
      email: "arun@test.com",
      role: "User",
      status: "Inactive",
    },
    {
      id: 3,
      name: "Karthik",
      email: "karthik@test.com",
      role: "Manager",
      status: "Active",
    },
    {
      id: 4,
      name: "Divya",
      email: "divya@test.com",
      role: "User",
      status: "Active",
    },
    {
      id: 5,
      name: "Sneha",
      email: "sneha@test.com",
      role: "HR",
      status: "Inactive",
    },
  ];

  //   const columns = useMemo(
  //     () =>
  //       [
  //         {
  //           Header: "S.NO",
  //           accessor: "",
  //           Cell: (row) => {
  //             console.log(row.row);
  //             console.log(sno);
  //             return <p>{Number(sno + row.row.index + 1)}</p>;
  //           },
  //         },
  //         {
  //           Header: "Name",
  //           accessor: "name",
  //           Cell: (row) => {
  //             return <p>{row.row.original.name}</p>;
  //           },
  //         },
  //         {
  //           Header: "Actions",
  //           accessor: "",
  //           Cell: (row) => {
  //             return (
  //               <>
  //                 <div
  //                   class="actions"
  //                   style={{
  //                     display: "flex",
  //                     justifyContent: "flex-start",
  //                     gap: "5px",
  //                   }}
  //                 >
  //                   <button
  //                     type="button"
  //                     class="btn Status"
  //                     onClick={(e) => {
  //                       e.stopPropagation();
  //                       setsearch("");
  //                       setDeleteId(row.row.original.id);
  //                       setDeletePopup(true);
  //                     }}
  //                   >
  //                     <span className="OuterActionSpan">
  //                       <span className="EditImages">
  //                         <img src={DeleteImages} />
  //                       </span>

  //                       <span className="ActionsList"> Delete </span>
  //                     </span>
  //                   </button>
  //                 </div>
  //               </>
  //             );
  //           },
  //         },
  //       ][(sno, sampleData)],
  //   );

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch"
          style={{
            padding: "14px 28px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px !important",
          }}
        >
          <div
            // className="InnerUsers col-md-6"
            class="col-sm-7 auto"
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 class="user-name mb-0">Verification Bulkupload</h3>
          </div>
          <div
            className="Add-User col-sm-5"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              justifyContent: "flex-end",
            }}
          >
            <button
              onClick={(e) => {
                navigate("/verificationbulkupload/preview");
              }}
              className="ButtonCSS"
              style={{ marginBottom: "10px" }}
            >
              Bulkupload Status
            </button>
            <button
              onClick={(e) => {
                setBulkUploadPopup(true);
              }}
              className="ButtonCSS"
              style={{ marginBottom: "10px" }}
            >
              Bulk Upload
            </button>
          </div>
        </div>
        <div
          style={{
            padding: " 0px 40px",
            marginTop: "-13px",
            marginBottom: "20px",
          }}
        >
          <ReactTable
            data={employeeBulkUploaddata ? employeeBulkUploaddata : []}
            columns={columns}
            // totalItems={state.ReportSheetData.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            // datacount={state.ReportSheetData.Total_Count}
            // datacount={state.ReportSheetData?.Total_Count}
            totalItems={totalCount}
            datacount={totalCount}
            MakeCreate={false}
            ///--- emoloyee role based filters -
            // Filter={true}
            // EmployeeRoleTrue={false}
            // EmployeeRoleOption={EmpRoles}
            // EMpROleSelected={EMpROleSelected}
            // HandleEMprole={HandleEMprole}
            //---status
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            // value={StatusVal}
            // options={options}
            // count={count}
            // ClearState={ClearState}
            placeHold={"All"}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            ApproveRequestFilter={true}
            search_key={true}
          />
        </div>
        {bulkUploadPopup && (
          <EmployeeBulkuploadPopup setPopup={setBulkUploadPopup} />
        )}
      </div>
    </>
  );
};

export default EmployeeBulkuploadMain;
